import React, { useMemo } from "react";
import PropTypes from "prop-types";
import CustomSelect from "./CustomSelect";

const Dropdown = ({ handleChange, options, selection }) => {
  const cleanOptions = useMemo(() => {
    return options.map((datum) => ({ value: datum.id, label: datum.name }));
  }, [options]);

  return (
    <div className="dropdown__container">
      <CustomSelect
        className="dropdown__input"
        closeMenuOnSelect
        value={selection}
        isDisabled={false}
        isLoading={false}
        // isClearable
        backspaceRemovesValue
        isSearchable
        options={cleanOptions}
        onChange={handleChange}
        placeholder="Search by county..."
        maxMenuHeight={170}
      />{" "}
    </div>
  );
};

Dropdown.propTypes = {
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  selection: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
};

export default Dropdown;
